import { ClientRecorder } from '@/components/ClientRecorder'
import { RouterContext } from '@/main'
import { getLocale } from '@/stores/i18n'
import { FALLBACK_LANGUAGE } from '@repo/constants'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { resources } from '../i18n'

// Registered before init so the initial `languageChanged` covers the first
// paint too. A correct `<html lang>` is what stops Chrome from offering to
// auto-translate a page already in the visitor's language — its DOM mutations
// crash React (insertBefore) on re-render-heavy pages like onboarding.
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
})

i18n.use(initReactI18next).init({
  lng: getLocale(),
  resources,
  fallbackLng: FALLBACK_LANGUAGE,
  debug: !!import.meta.env.DEV,
  interpolation: {
    escapeValue: false,
  },
  saveMissing: true,
})

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  return (
    <>
      <Outlet />
      <ClientRecorder />
    </>
  )
}
